import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const NavigationContext = createContext({
  previousPage: '',
  currentPage: '',
  wasFlyerDetailsPage: false,
  isLoading: false,
});

export const NavigationProvider = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { pathname, search } = location;
  const [navigationState, setNavigationState] = useState({
    previousPage: '',
    currentPage: pathname + search,
  });

  useEffect(() => {
    setNavigationState(prev => ({
      previousPage: prev.currentPage,
      currentPage: pathname + search,
    }));
  }, [pathname, search]);

  const props = {
    ...navigationState,
    wasFlyerDetailsPage: Boolean(navigationState.previousPage.match('flyer')),
    isLoading: navigationState.currentPage !== pathname + search,
  };

  return <NavigationContext.Provider value={props}>{children}</NavigationContext.Provider>;
};
